class MySkillsController {
  constructor(UserDataService, $rootScope) {
    // Dependencies
    this.UserDataService = UserDataService;
    this.$rootScope = $rootScope;

    // Component Variables
    this.skills = this.UserDataService.skills;
  }
  autosave() {
    this.UserDataService.freshData = false;
    this.UserDataService.saveUserData('skills');
    this.UserDataService.saveUserData('freshData');
  }

  selectNext() {
    this.$rootScope.$emit('OPEN_INTERESTS');
  }
}

MySkillsController.$inject = ['UserDataService', '$rootScope'];

export default MySkillsController;



// WEBPACK FOOTER //
// ./src/components/mySkills/mySkills.controller.js